import Axios from "axios";
import { BulmaButton } from "Components/Button";
import { Horizontal } from "Components/Horizontal";
import { LcpUserPageWrapper } from "Components/MainPageWrapper";
import { Section } from "Components/Section";
import { EnterKeyCatcher } from "Inputs/EnterKeyCatcher";
import { useFormWithSchema } from "Inputs/FormTools";
import { Textbox } from "Inputs/Textbox";
import { YupDefined } from "Inputs/Tools";
import * as querystring from "query-string";
import React, { useContext, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { serverConstants } from "Shared/Constants";
import { hasValue } from "Tools";
import * as Yup from "yup";
import { AdminPaths, PublicPaths } from "./Paths";
import { UserContext } from "./UserProvider";

export function LogInPage() {
  const history = useHistory();
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (hasValue(user)) {
      history.push(AdminPaths.AdminDashboard);
    }
  }, [user]);

  const formik = useComponentFormik();
  return (
    <LcpUserPageWrapper documentTitle="Log In">
      <Section title="Log In">
        <EnterKeyCatcher handleSubmit={formik.handleSubmit}>
          <div
            className="narrowFieldBodies3"
            style={{ margin: "auto", maxWidth: "480px" }}
          >
            <Horizontal label="Email" isRequired>
              <Textbox
                type="email"
                fieldProps={formik.field.getSubField("username")}
                placeholder={`name@${serverConstants.StaticSiteHost}`}
                style={{ flexGrow: 1 }}
              />
            </Horizontal>
            <Horizontal label="Password" isRequired>
              <Textbox
                type="password"
                fieldProps={formik.field.getSubField("password")}
                placeholder="password"
                style={{ flexGrow: 1 }}
              />
            </Horizontal>
          </div>
        </EnterKeyCatcher>
        <div className="has-text-centered" style={{ marginTop: "1em" }}>
          <BulmaButton
            className="is-primary"
            onClick={formik.submitForm}
            isSubmitting={formik.isSubmitting}
          >
            Log In
          </BulmaButton>
        </div>
        <div className="has-text-centered" style={{ marginTop: "1em" }}>
          <Link to={PublicPaths.ForgotPassword}>Forgot Password?</Link>
        </div>
      </Section>
    </LcpUserPageWrapper>
  );
}

export function useComponentFormik() {
  const history = useHistory<any>();
  return useFormWithSchema({
    initialValues: { username: null, password: null },
    onSubmit: async (values, handlers) => {
      try {
        await Axios.post("/api/User/LogIn", values);
        // NOTE: ASP.NET generates redirect links as /LogIn?ReturnUrl=...
        const decodedQueryString = querystring.parse(history.location.search);
        const returnUrl =
          decodedQueryString.ReturnUrl instanceof Array
            ? decodedQueryString.ReturnUrl[0]
            : decodedQueryString.ReturnUrl;
        window.location.href = returnUrl ?? AdminPaths.AdminDashboard;
      } catch (error) {
        handlers.setErrors({
          password:
            "Could not log in.  Please check your credentials and try again.",
        });
      }
    },
    validationSchema: Yup.object({
      username: YupDefined.string()
        .nullable()
        .label("Username")
        .email("Please enter a valid email.")
        .required(),
      password: YupDefined.string().nullable().label("Password").required(),
    }),
  });
}
